import React from  "react"
import { useState, useEffect, useRef} from "react"
import { Formik, Form, useField, FormikProps } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import CommonVars from "../Component/CommonVars";
import {
    Flex,
    Heading,
    Input,
    Button,  
    Stack,
    chakra,
    Box,
    Link,
    Avatar,
  } from "@chakra-ui/react";
  import { FaUserAlt, FaLock } from "react-icons/fa";

  const MyTextField = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    return (
      <>
        <label>
          {label}
        </label>

        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };


function AddCategoryScreen(props){

    const [getDetails, setDetails] = useState('')
    
    useEffect(()=>{
        // var form = document.querySelector("form");;
        // form.addEventListener("submit", function(event){
        // event.preventDefault()
        // });
    }, [])

    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const headers = {
        "Content-Type": "application/json",
    }
    return(
        <Formik
            initialValues={{
                categoryname: ''
            }}

        validationSchema={Yup.object({
            categoryname: Yup.string()
            .required('Required'),
        })}



        onSubmit = {values =>{
            const token = localStorage.getItem('token')
    
            const Categorybody= values;
            console.log(values)
            console.log(Categorybody )
            axios.post(`${CommonVars.API_URL}/category`, Categorybody,{headers:{Authorization : `Bearer ${token}`} },{
                headers: headers
            })
            .then((response)=>{
                console.log(response)
                var data = response.data
                console.log(data)
                alert("Added Category")
                window.location.href="/";
            })
        }

        }
        >
                    {props => (
  <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
    >
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p> 
        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Avatar bg="gray.500" />
        <Heading color="black.400">Add Category</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>

          <Form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
                   <MyTextField name="categoryname" type="categoryname" label="Category Name" />
                
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="gray"
                width="full"
              >
                                    {props.isSubmitting ? 'Adding Category' : 'Add Category'}
              </Button>
            </Stack>
          </Form>

        </Box>
      </Stack>
    </Flex>
                     )}
        </Formik>
    )

}

export default AddCategoryScreen;